import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import {
  displayIdNumber,
  formatBirthdate,
  formatColor,
  getFullName,
} from 'dashboard/components/ChecksTable/computeCheckMetadata/utils';
import { formatDate } from 'dashboard/lib/utils/formatters';
import { IdBarcodeDetection } from 'dashboard/models/check';

export const computeIdBarcodeDetectionMetadata = (
  check: IdBarcodeDetection,
  hasPermissionVerificationGovIdNumberView: boolean,
): CheckMetadata => {
  const {
    eyes,
    hair,
    height,
    sex,
    weight,
    'vehicle-class': vehicleClass,
    'expiration-date': expirationDate,
    'issue-date': issueDate,
    'identification-number': identificationNumber,
    birthdate,
  } = check.metadata || {};

  return {
    metadata: createSimpleCheckMetadataArray([
      {
        label: 'Name',
        value: check.metadata && getFullName(check.metadata),
      },
      {
        label: 'Birthdate',
        value: formatBirthdate(birthdate),
      },
      {
        label: 'Sex',
        value: sex,
      },
      {
        label: 'Hair',
        value: formatColor(hair),
      },
      {
        label: 'Eyes',
        value: formatColor(eyes),
      },
      {
        label: 'Height',
        value: height,
      },
      {
        label: 'Weight',
        value: weight,
      },
      {
        label: 'Issue Date',
        value: formatDate(issueDate),
      },
      {
        label: 'Expiration Date',
        value: formatDate(expirationDate),
      },
      {
        label: 'Vehicle Class',
        value: vehicleClass,
      },
      {
        label: 'Identification Number',
        value: displayIdNumber(identificationNumber, hasPermissionVerificationGovIdNumberView),
      },
    ]),
    hideIfVerificationPassed: false,
  };
};
